import axios from "axios";


export const createAlignOrder = async (order) =>
await axios.post(`${process.env.REACT_APP_API}/align-books-order`, { order });

